import * as React from "react";

import "./control-panel.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

import {DesktopControlPanel} from "../../common/desktop-control-panel/desktop-control-panel";
import {MobileControlPanel}  from "../../common/mobile-control-panel/mobile-control-panel";

export const ControlPanel = ({mobile, hasFile, onCancel, onDone, fileUpload, editing}) => cs(
    () => mobile ? cs(
        ["changingFile", (_, next) => UseState({next})],
        ({changingFile}) => (changingFile.value || !hasFile) ? (
            MobileControlPanel({
                fullView: true,
                onDone,
                onCancel: () => {
                    changingFile.value ? (
                        changingFile.onChange(false)
                    ) : (
                        onCancel()
                    );
                },
                content: (
                    <div {...{
                        className: "control-panel-6yp mobile full-view",
                        "xd-qa-type": "card",
                        "xd-qa-name": "Mask Mode",
                    }}>
                        {fileUpload({
                            mobile: true,
                            onChanged: () => changingFile.onChange(false),
                        })}
                    </div>
                ),
            })
        ) : (
            MobileControlPanel({
                onCancel,
                onDone,
                extraAction: {
                    icon: "fa-picture-o",
                    text: "Change Mask",
                    onClick: () => changingFile.onChange(true),
                },
                content: (
                    <div {...{
                        className: "control-panel-6yp mobile",
                        "xd-qa-type": "card",
                        "xd-qa-name": "Mask Mode",
                    }}>
                        {editing({mobile: true})}
                    </div>
                ),
            })
        )
    ) : (
        DesktopControlPanel({
            onCancel,
            onDone,
            content: (
                <div {...{
                    className: "control-panel-6yp desktop",
                    "xd-qa-type": "card",
                    "xd-qa-name": "Mask Mode",
                }}>
                    {fileUpload({})}

                    {editing({})}
                </div>
            ),
        })
    ),
);
